import { ReactNode } from "jsx-dom";
import { defaultClasses } from "./buttonStyles";

export type LinkButtonProps = {
  href: string;
  children: ReactNode;
  cssClass?: string;
  testId?: string;
  onClick?: () => void;
};

export const LinkButton = ({
  href,
  children,
  cssClass,
  testId,
  onClick,
}: LinkButtonProps) => {
  return (
    <a
      href={href}
      data-testId={testId}
      className={`${defaultClasses} ${cssClass}`}
      onClick={() => onClick && onClick()}
    >
      {children}
    </a>
  );
};
